import { AuthModel, authModel } from './auth';
import { versionModel, VersionModel } from './version';
import { PermissionsModel, permissionsModel } from './permissions';

export interface StoreModel {
  auth: AuthModel;
  version: VersionModel;
  permissions: PermissionsModel;
}
export const storeModel: StoreModel = {
  auth: authModel,
  version: versionModel,
  permissions: permissionsModel,
};
